var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}]})])
}
var staticRenderFns = []

export { render, staticRenderFns }